import { Box } from "@/components/core-components";
import styled from "styled-components";

export const MemberRow = styled(Box)`
  gap: ${({ theme }) => theme.spacings.xs3};
  align-items: center;

  padding: ${({ theme }) => `${theme.spacings.xs3} 0`};

  position: relative;

  & + &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -${({ theme }) => theme.spacings.xs2};
    right: -${({ theme }) => theme.spacings.xs2};
    height: ${({ theme }) => theme.borders.width.xs2};
    background-color: ${({ theme }) => theme.colors.neutral[90]};
  }
`;
